import React, { useContext } from 'react';
import AppContext from 'context/Context';
import SidebarCustomerHeader from './SidebarCustomerHeader';
import SidebarTicketDetails from './SidebarTicketDetails';
import SidebarTicketNotes from './SidebarTicketNotes';
import SidebarCustomerLicenses from './SidebarCustomerLicenses';
import SidebarTicketHistory from './SidebarTicketHistory';

const TicketCustomerSidebar = ({
  ticket,
  isLoadingDetail = false,
  onTicketUpdated,
  participants = [],
  isLoadingParticipants = false,
  onReloadParticipants,
  historyRefreshKey = 0,
  onOpenCombinedMessages,
  notes,
  isLoadingNotes,
  isSavingNote,
  createNote,
  updateNote,
  deleteNote
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  return (
    <div
      className={`p-3 d-flex flex-column gap-3 h-100 border-start se-custom-scrollbar ${isDark ? 'se-dark-scrollbar' : ''}`}
      style={{
        width: '320px',
        minWidth: '300px',
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#dee2e6',
        overflowY: 'auto',
        height: '100%',
        maxHeight: '100%',
        scrollbarWidth: 'thin',
        scrollbarColor: isDark ? '#2b394a transparent' : '#cbd5e1 transparent'
      }}
    >
      {/* 1. Header / Perfil del cliente */}
      <SidebarCustomerHeader ticket={ticket} onTicketUpdated={onTicketUpdated} />

      {/* 2. Nivel de soporte y detalles del ticket actual */}
      <SidebarTicketDetails
        ticket={ticket}
        isLoading={isLoadingDetail}
        onTicketUpdated={onTicketUpdated}
        participants={participants}
        isLoadingParticipants={isLoadingParticipants}
        onReloadParticipants={onReloadParticipants}
      />

      {/* 3. Notas internas del ticket */}
      <SidebarTicketNotes
        ticket={ticket}
        notes={notes}
        isLoadingNotes={isLoadingNotes}
        isSavingNote={isSavingNote}
        createNote={createNote}
        updateNote={updateNote}
        deleteNote={deleteNote}
      />

      {/* 4. Licencias y pólizas del cliente */}
      <SidebarCustomerLicenses idClienteAkasia={ticket.idClienteAkasia} />

      {/* 5. Historial de tickets y movimientos */}
      <SidebarTicketHistory
        idClienteAkasia={ticket.idClienteAkasia}
        currentTicketId={ticket.id}
        ticketState={ticket.iEstadoTicket}
        ticketLevel={ticket.idCatNivelSoporte}
        historyRefreshKey={historyRefreshKey}
        ticket={ticket}
        onOpenCombinedMessages={onOpenCombinedMessages}
      />
    </div>
  );
};

export default TicketCustomerSidebar;
